import Image from 'app/Components/Shared/Image/image';
import React from 'react';
import { prepareNewWindowUrl } from '../../../utilities/StringHelpers/StringHelpers';
import Config from '../../../Config';
import BtnSubmit from '../../Shared/Buttons/BtnSubmit';
import {createReportUpgradeCellularDeviceClickBtn} from '../../../utilities/reports/createReport';
const UpgradeCellularDeviceSwiperMobile = (props) => {

  return (
    <>
      {props.upgradeCellularDeviceObj?.items?.map((item, i) => (
        <div className='upgrade-cellular-device-mobile-container'>
          <div className='borderImageMobile'>
            <Image src={Config.epiBaseUrl + item.mobileImage?.value?.url} className='imageContainer' />
          </div>
          <div className='infoData'>
            <div className='description'>
              <span>{item.description?.value}</span>
            </div>
            <div className='linkDetails'>
              <a onClick={() => {prepareNewWindowUrl(item?.linkDetails?.value, props.context),createReportUpgradeCellularDeviceClickBtn('Device Order Button Clicked',item.description?.value)}}>
                {props?.upgradeCellularDeviceObj?.linkDetailsString}
              </a>
              <div className='leftArrowDetails' />
            </div>
          </div>
          <BtnSubmit
            className='btn-purchase'
            onclick={() => {
              props.setShowPopUp(true), props.setItemInfo(item), props.setIsWorkOrderSucceeded(''),createReportUpgradeCellularDeviceClickBtn('Info Link Clicked',item.description?.value);
            }}
            text='להזמנה'
          />
        </div>
      ))}
    </>
  );
};

export default UpgradeCellularDeviceSwiperMobile;
